import React, { useEffect, useState, useRef } from 'react';
import BaseLayout from 'Components/Layout/BaseLayout';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Breedcumb from 'Components/Breedcumb/Breedcumb';
import { useDispatch, useSelector } from 'react-redux';
import axiosInstance from 'Utils/Interceptor';
import { ReactDatePickerTimeConverter } from 'Utils/Functions';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import PackageImage from 'Assets/Icons/PackageFamilyImageForHomePage.png';

function Offers() {
  const location = useLocation();
  const [coupons, setCoupons] = useState([]);
  const { cityId } = useSelector((state) => state?.location);
  const [expandedCoupons, setExpandedCoupons] = useState({});

  const dispatch = useDispatch();
  const textRefs = useRef({});

  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/user/offers?city=${cityId}&is_mobile=false`
        );
        setCoupons(response?.data?.data);
      } catch (error) {
        console.error('Error fetching coupons:', error);
      }
    };

    fetchCoupons();
  }, [cityId]);

  const toggleExpand = (couponCode) => {
    setExpandedCoupons((prev) => ({
      ...prev,
      [couponCode]: !prev[couponCode]
    }));
  };

  return (
    <BaseLayout
      _class={
        'header-top-offset booking-process-header my-booking-details-page my-booking-main-page'
      }
      from={'LocateLab'}
    >
      <Helmet>
        <link
          rel="canonical"
          href={`${process.env.REACT_APP_URL}${location.pathname}`}
        />
        <title>
          Unipath Lab Near You - Locate Your Nearest Diagnostic Center
        </title>
        <meta
          name="keywords"
          content=""
        />
        <meta
          name="description"
          content="Easily locate a Unipath pathology lab near you for reliable diagnostic tests and health checkups. Find the nearest center and book your lab test today."
        />
      </Helmet>
      <Breedcumb list={[{ text: 'Offers' }]} />

      <section className="test-listing-section pt-0 tag-interchange">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="heading-component">
                <h1>Offers</h1>
                <p>
                  Unipath offers are given only on select tests and packages
                  from time-to-time. While some offers are available for both
                  online and offline customers, few offers are available only
                  for mobile application customers. Stay connected and keep
                  yourself updated on all attractive discount offers!’ At one
                  time only one discount offer can be availed. Two discount
                  offers can not be availed in one booking.
                </p>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="search-result-wrapper offers-search-result-wrapper">
                {coupons.map((coupon) => {
                  const packageDetails = coupon.package_details;
                  const isExpanded = expandedCoupons[coupon.coupon_code];

                  return (
                    <div
                      className="search-result-item"
                      key={coupon.coupon_code}
                    >
                      <div className="search-result-item-content offers-item-card">
                        <div className="offers-listing-card-wrapper">
                          <figure className="offers-listing-card-image">
                            <img
                              src={coupon.image}
                              alt={PackageImage}
                            />
                          </figure>
                          <div className="offers-listing-card-content">
                            <div className="offers-listing-heading">
                              <h3>{coupon.coupon_name}</h3>
                              <p>{coupon.coupon_termscondition}</p>
                            </div>

                            <h4 className="mb-2 d-flex gap-2">
                              {coupon.coupon_code}
                              <div
                                className="text-secondary copy-offers"
                                onClick={() => {
                                  navigator.clipboard.writeText(
                                    coupon.coupon_code
                                  );
                                  toast.success('Code copied to clipboard');
                                }}
                              >
                                <FontAwesomeIcon icon={faCopy} />
                              </div>
                            </h4>
                            <p>
                              <h3>Available Centres:</h3>{' '}
                              <div class="city-list">
                                <span class="city">Ahmedabad,</span>
                                <span class="city">Surat,</span>
                                <span class="city">Vadodara,</span>
                                <span class="city">Jamnagar,</span>
                                <span class="city">Anand,</span>
                                <span class="city">Kolkata,</span>
                                <span class="city">Jaipur,</span>
                                <span class="city">Siliguri,</span>
                                <span class="city">Indore,</span>
                                <span class="city">Jabalpur,</span>
                                <span class="city">J&amp;K,</span>
                                <span class="city">New Panvel</span>
                              </div>
                            </p>
                            <p>
                              Expires on{' '}
                              {ReactDatePickerTimeConverter(coupon.expiry)}
                            </p>
                            <p className="color-red">
                              {coupon.termsandcondition}
                            </p>
                          </div>
                        </div>

                        <div
                          ref={(el) =>
                            (textRefs.current[coupon.coupon_code] = el)
                          }
                          className={`offers-health-packages-list ${
                            isExpanded ? 'expanded' : ''
                          }`}
                        >
                          <h5>{coupon.service_head}</h5>
                          <ul className="included-packages">
                            {Array.isArray(packageDetails) &&
                            packageDetails.length > 0 ? (
                              packageDetails
                                .slice(
                                  0,
                                  isExpanded ? packageDetails.length : 6
                                )
                                .map((packageDetail, index) => (
                                  <li key={index}>{packageDetail}</li>
                                ))
                            ) : (
                              <li>No package details available.</li>
                            )}
                          </ul>
                          {packageDetails.length > 6 && (
                            <button
                              className="btn-link"
                              onClick={() => toggleExpand(coupon.coupon_code)}
                            >
                              {isExpanded ? 'See less ' : 'See more '}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </BaseLayout>
  );
}

export default Offers;
